module.exports = __webpack_public_path__ + "static/media/3.c6f7bc76.jpg";